import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { FinanceEntityIdSchema } from './finance-entity-id.ts'
import { UbsEntityIdSchema } from './ubs-entity-id.ts'

export const EntityKindSchema = z.enum([
  'advertiser',
  'brand',
  'creator',
  'agency',
])
export type EntityKind = ZodInfer<typeof EntityKindSchema>

export const PlatformSchema = z.enum(['premier', 'quickframe', 'mntn_select'])
export type Platform = ZodInfer<typeof PlatformSchema>

export const UbsEntitySchema = z.object({
  ubsEntityId: UbsEntityIdSchema,
  kind: EntityKindSchema,
  name: z.string().min(1),
  originPlatform: PlatformSchema.optional(),
  financeEntityId: FinanceEntityIdSchema.optional(),
  metadata: z.record(z.string(), z.any()),
  createdAt: DateStringSchema,
  updatedAt: DateStringSchema,
})

export type UbsEntity = ZodInfer<typeof UbsEntitySchema>
